// Build-time feature flags. CRA inlines REACT_APP_* env vars at build time.
// These are the source of truth for which flags exist; set them in each
// environment's .env / deployment config (all default off/empty here).

// Auri (the chat widget) is external and not yet integrated into this repo.
// While it's off (default), every "Auri pops in" touchpoint renders the
// AuriPlaceholder hand-off screen instead of a live widget. Set
// REACT_APP_AURI_ENABLED="true" once Auri is wired up.
export const AURI_ENABLED = process.env.REACT_APP_AURI_ENABLED === "true"

// GHL booking calendar for the soft-exit "Connect me with a navigator" CTA.
// Empty until the URL is provided; callers should guard on it.
export const GHL_NAVIGATOR_BOOKING_URL =
  process.env.REACT_APP_GHL_NAVIGATOR_BOOKING_URL || ""
